import { FieldDefinition } from '@/services/property/property.type'
import { GraphQLResult } from 'aws-amplify/api'
import { AmplifyGraphQLClient } from '../amplifyClient'

export type PropertyDefinition = {
  id: string
  name: string
  version: string
  organizationPropertiesId: string
  organization: { name: string }
  fields: { items: { id: string; field: FieldDefinition }[] }
}

type GetPropertyResponse = {
  getProperty: PropertyDefinition
}

/**
 * Get a property by its id and language
 * Returns only the property definition, not the options (use fetchAllOptionsByField for that)
 */
export const getProperty = async ({
  id,
  client,
}: {
  id: string
  client: AmplifyGraphQLClient
}) => {
  const { data } = (await client.graphql<GetPropertyResponse>({
    query: /* GraphQL */ `
      query GetProperty($id: ID!) {
        getProperty(id: $id) {
          id
          name
          version
          organizationPropertiesId
          organization {
            name
          }
          fields(limit: 10000) {
            items {
              id
              field {
                id
                key
                label
                value
                type
                organizationFieldsId
                organization {
                  id
                  name
                }
                updatedAt
                metadata {
                  key
                  value
                  type
                }
                translations(limit: 100) {
                  items {
                    id
                    label
                    lang
                    updatedAt
                  }
                }
              }
            }
          }
        }
      }
    `,
    variables: { id },
  })) as GraphQLResult<GetPropertyResponse>
  return data?.getProperty
}
